import { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import AsyncSelect from 'react-select/async';
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import { useSession } from "../components/SessionProvider";
import { useApi } from "../hooks/useApi";


export default function AddUser() {
    const { email } = useParams();  // Get the user ID from the URL
    const [userData, setUserData] = useState(null);
    const [selectedSites, setSelectedSites] = useState([]);
    const [decodedEmail, setDecodedEmail] = useState('');
    const { apiCall } = useApi();
    const initialized = useRef(false);
    const navigate = useNavigate();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const { userLogin } = useSession();
    const baseName = import.meta.env.VITE_APP_BASE_URL;

    const loadSiteOptions = async (inputValue, callback) => {
        if (!inputValue) return callback([]);
        try {
            const response = await apiCall(`search_sites`, { params: { search_term: inputValue } });
            const data = await response.json();
            const options = data.map(site => ({
                value: site.id,
                label: `${site.site_number} - ${site.site_name}`
            }));
            callback(options);
        } catch (error) {
            console.error("Error loading sites", error);
            callback([]);
        }
    };

    useEffect(() => {
        const decoded = atob(email);
        if (!initialized.current) {
            initialized.current = true;
            setDecodedEmail(decoded);

            apiCall(`user-fetch_user`, { params: { user_email: decoded } })
                .then(response => response.json())
                .then(data => {
                    setUserData(data);
                    if (data && data.sites && data.sites.length) {
                        const defaultSites = data.sites.map(site => ({
                            value: site.id,
                            label: `${site.site_number} - ${site.site_name}`
                        }));
                        setSelectedSites(defaultSites);
                    }
                })
                .catch(error => console.error("Error fetching user data:", error));
        }
    }, [email]);

    const setData = (key, value) => {
        setUserData((prevData) => ({ ...prevData, [key]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userDataNew = userData;
        userDataNew.site_ids = selectedSites.map(site => site.value);

        try {
            const response = await apiCall(`user-update_user`, {
                params: { user_email: decodedEmail },
                method: "POST",
                body: userDataNew
            });
            const data = await response.json();
            if (!data.success) {
                throw new Error("Failed to add the user");
            }

            alert("User updated successfully!");
            window.location.origin + baseName + `users`;
        } catch (error) {
            console.error("Error adding the user:", error);
            alert("Error adding the user. Please try again.");
        }
    }
    const deleteUser = async () => {

        if (inProgress) return;
        setInProgress(true);

        try {
            const response = await apiCall(`user-delete_user`, { params: { user_email: decodedEmail } });
            const data = await response.json();
            setInProgress(false);
            if (!data.success) {
                throw new Error(data.error);
            }
            navigate("/users"); // Redirect to the sites list page after deletion
        } catch (error) {
            alert(error);
        }
    }

    const readonlyHandleChange = async (e) => {
        setData('read_only', e.target.checked ? 1 : 0);
        if (e.target.checked) {
            setData('emails_enabled', 0);
        }

    }

    return (
        <>
            {dialogOpen && (
                <ConfirmDialog
                    open={dialogOpen}
                    title="Delete User"
                    message={
                        <>
                            Are you sure you want to remove <b>{decodedEmail}</b>?
                            This action cannot be undone.
                        </>
                    }
                    inProgress={inProgress}
                    confirmText="Confirm Delete"
                    onConfirm={deleteUser}
                    onCancel={() => { setDialogOpen(false) }}
                />
            )}

            {!userData || !userData.user_email && (
                <div className="flex justify-center items-center mt-10 mb-10">
                    <div>No such user found</div>
                </div>
            )}
            {userData && userData.user_email && (
                <div className="p-6">
                    <div className="flex justify-between items-center mb-10">
                        <div>
                            <h1 className="text-2xl font-bold mb-3">Edit User</h1>
                            {userData.user_email ? (
                                <h2 className="text-xl font-bold">Email: {userData.user_email}</h2>
                            ) : null}
                            {userData.user_name ? (
                                <h2 className="text-xl font-bold">Name: {userData.user_name}</h2>
                            ) : null}
                            {userData.phone ? (
                                <h2 className="text-xl font-bold">Phone: {userData.phone}</h2>
                            ) : null}
                        </div>

                        <Link to={`/users/`} className="btn btn-primary self-end">
                            Back
                        </Link>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        {/* <input
                            type="email"
                            placeholder="User Email"
                            value={userData ? userData.user_email : ""}
                            onChange={(e) => setData('user_email', e.target.value)}
                            className="border p-2 rounded w-full"
                            required
                        /> */}
                        {/* <input
                            type="text"
                            placeholder="User Name"
                            value={userData ? userData.user_name : ""}
                            onChange={(e) => setData('user_name', e.target.value)}
                            className="border p-2 rounded w-full"
                            required
                        /> */}
                        <div>
                            <label className="block text-sm font-medium mb-1">Assign Projects</label>
                            <AsyncSelect
                                isMulti
                                loadOptions={loadSiteOptions}
                                defaultOptions
                                onChange={setSelectedSites}
                                value={selectedSites}
                                placeholder="Search job sites..."
                            />
                        </div>
                        <label className="flex w-fit mb-4">
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={parseInt(userData.read_only)}
                                onChange={readonlyHandleChange}
                            />
                            Read only?
                        </label>
                        <label className="flex w-fit mb-4">
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={parseInt(userData.all_site_access)}
                                onChange={(e) => setData('all_site_access', e.target.checked ? 1 : 0)}
                            />
                            All site Access?
                        </label>
                        <label className="flex w-fit mb-4">
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={parseInt(userData.emails_enabled)}
                                onChange={(e) => setData('emails_enabled', e.target.checked ? 1 : 0)}
                            />
                            Receive emails?
                        </label>

                        {userLogin.isAdminManager && (
                            <label className="flex w-fit mb-4">
                                <input
                                    type="checkbox"
                                    className="mr-2"
                                    checked={parseInt(userData.is_tester)}
                                    onChange={(e) => setData('is_tester', e.target.checked ? 1 : 0)}
                                />
                                Tester?
                            </label>
                        )}
                        <div className="flex items-center mb-4 justify-between">
                            <div className="flex items-center mr-4">
                                <button type="submit" className="btn btn-primary">Update User</button>
                                <Link to={`/users/`}>
                                    <button type="button" className="btn btn-cancel ml-4">Cancel</button>
                                </Link>
                            </div>
                            {userLogin.isAdminManager && (
                                <button type="button" className="bg-red-500 text-white p-2 rounded cursor-pointer ml-4" onClick={(e) => { setDialogOpen(true); }}>Delete User</button>
                            )}
                        </div>


                    </form>
                </div>
            )}
        </>
    );

};